import moment from "moment";
import 'moment/locale/pt-br';

if (moment.locale() !== 'pt-br') {
  moment.locale('pt-br');
}

const momentBR = moment;
export default momentBR;
